import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useDispatch } from 'react-redux';
// import { useUpdateEffect } from 'react-use';
// import { useWhisper } from '@chengsokdara/use-whisper';
// // import classNames from 'classnames';
// import removeMd from 'remove-markdown';
import { selectUser } from 'selectors';
import styled from 'styled-components';
import { Box, Container, responsive, Image } from 'styled-minimal';

// import useTreeChanges from 'tree-changes-hook';
import { useAppSelector } from 'modules/hooks';
// import { headerHeight } from 'modules/theme';

import { coaches } from 'config';
import { STATUS } from 'literals';

import { userAnswer } from 'actions';

import Icon from 'components/Icon';
import Typing from 'components/Typing';

import { UserState } from 'types';
import Header from 'components/Header';

// import useTreeChanges from 'tree-changes-hook/lib';

const StyledBox = styled(Box)<Pick<UserState, 'coach'>>`
  background-size: cover;
  background-position: center;
  background-image: '${process.env.PUBLIC_URL}/media/images/venn-graph.png';
  // background: rgb(79, 169, 151);
  background: rgb(55, 65, 81);
  overflow: hidden;
  height: calc(100vh);
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
`;
const LeftSide = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const RightSide = styled.div`
  position: absolute;
  right: 0px;
  top: 0;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

const StyledContainer = styled(Container)<Pick<UserState, 'coach'>>`
  display: flex;
  flex-direction: column;

  background-color: white;
  max-width: 500px;
  padding: 0 20px 16px;
  width: 500px;
  border-radius: 0 20px 20px 0;

  & > ul {
    & > li {
      list-style-type: none;
    }
  }

  & > ul {
    width: 100%;
    flex: 1;
    padding-right: 30px;
    padding-top: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    padding-left: 10px;

    ::-webkit-scrollbar {
      width: 10px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgb(151, 155, 166);
    }
    ::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: rgb(238, 238, 238);
    }
  }

  & > ul > li {
    margin-bottom: 20px;
    padding: 0 20px;
    position: relative;
    border-radius: 10px;
    font: 0.9em / 1.6 'Helvetica';
    max-width: 300px;
    /* background: ${({ coach }) =>
      `linear-gradient(to right, ${coaches[coach].primary}, ${coaches[coach].default})`}; */

    & > button {
      color: white;
      position: absolute;
      bottom: 10px;
      right: 10px;
    }

    ${responsive({
      md: { font: "1em / 1.8 'Helvetica'" },
    })};
    // color: rgba(255, 255, 255, 0.9);
    color: white;
    background: #374151;
    // text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.75);
    clear: both;
  }
  & > ul > li:nth-child(odd) {
    float: left;
    /* ${responsive({
      md: { marginLeft: '80px' },
    })}; */
  }
  & > ul > li:nth-child(even) {
    float: right;
    margin-right: 0px;
    /* ${responsive({
      md: { marginRight: '80px' },
    })}; */
    // background: linear-gradient(to right, #4c5094, #6d71ba);
    background: #600b68;
    color: white;
  }
  & > ul > li:before,
  & > ul > li:after {
    position: absolute;
    content: '';
  }
  & > ul > li:before {
    width: 60px;
    height: 60px;
    top: -6px;
    border-radius: 50%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    backround-position: center;
    display: none;
    ${responsive({
      md: { display: 'block' },
    })};
  }
  /* & > ul > li:nth-child(odd):before {
    left: -80px;
    border: 3px solid ${({ coach }) => coaches[coach].primary};
    background-image: url('${({ coach }) =>
    `${process.env.PUBLIC_URL}/media/images/${coaches[coach].avatar}.png`}');
  }
  & > ul > li:nth-child(even):before {
    right: -80px;
    background-image: url('${process.env.PUBLIC_URL}/media/images/avatar.png');
    border: 3px solid #4c5094;
  } */

  // ul>li:after {
  //   width: 0;
  //   height: 0;
  //   top: 15px;
  //   border-top: 15px solid rgba(255, 255, 255, 0.65);
  // }
  // ul>li:nth-child(odd):after {
  //   left: -15px;
  //   border-left: 15px solid transparent;
  // }
  // ul>li:nth-child(even):after {
  //   right: -15px;
  //   border-top-color: rgba(255, 255, 255, 0.3);
  //   border-right: 15px solid transparent;
  // }
`;

const Input = styled.textarea`
  border: none;
  background-image: none;
  background-color: white;
  padding: 0.5rem 1rem;
  border-radius: 1.125rem;
  flex-grow: 1;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.1), 0rem 1rem 1rem -1rem rgba(0, 0, 0, 0.2);
  letter-spacing: 0.025em;
  font: 0.9em 'Helvetica';
  line-height: 1.6;

  ${responsive({
    md: { fontSize: '1em' },
  })};
  outline: 2px solid grey;
`;

const Button = styled.button`
  width: 42px;
  height: 42px;
  background-color: white;
  border-radius: 50%;
  border: 3px solid transparent;
  color: rgb(79, 169, 151);

  &:hover {
    background-color: lightgrey;
  }

  &:active {
    color: white;
    background-color: #555;
  }
`;

const InputBox = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
`;

/*
const Actions = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
`;

const Action = styled.button`
  align-items: center;
  color: #fff;
  display: flex;
  font-size: 1.3rem;
  padding: 16px;

  ${responsive({ md: { fontSize: '1.6rem' } })};

  &.active {
    color: #fff;
  }
  span {
    display: inline-block;
    margin-right: 0.4rem;
    text-transform: none;
  }

  .icon {
    border-radius: 50px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    margin-right: 8px;
    border: 3px solid transparent;
    color: #374151;
  }

  &:hover .icon {
    background-color: lightgrey;
  }

  &:active .icon {
    color: white;
    background-color: #555;
  }
`;

const Listen = styled(Action)`
  .icon.checked {
    background-color: #7aa558;
    color: white;
  }

  &:hover .checked {
    background-color: #7aa55888;
  }

  &:active .checked {
    background-color: #777;
  }
`;

const Record = styled(Action)`
  .icon.checked {
    background-color: #b8357b;
    color: white;
  }
  &:hover .checked {
    background-color: #b8357b88;
  }
  &:active .checked {
    background-color: #777;
  }
`; */
// const Record = styled.button`
//   width: 50px;
//   height: 50px;
//   background: white;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

// const Recording = styled.div`
//   width: 30px;
//   height: 30px;
//   background: rgb(211, 55, 55);
//   border-radius: 50%;
// `;

function Chat() {
  const dispatch = useDispatch();
  const user = useAppSelector(selectUser);
  const { coach, messages, questions } = user;
  const question = questions[coach];
  const [audioRequest, setAudioRequest] = useState(true);

  const chat = useRef<HTMLUListElement>(null);
  const text = useRef<HTMLTextAreaElement>(null);
  const [input, setInput] = useState('');

  // const handleKeyDown = (event: KeyboardEvent) => {
  //   if (event.key === ' ' && !recording && document.activeElement !== text.current) {
  //     console.log('Recording started');
  //     startRecording();
  //   }
  // };

  // const handleKeyUp = (event: KeyboardEvent | React.KeyboardEvent) => {
  //   if (event.key === ' ') {
  //     console.log('Recording stopped');
  //     stopRecording();
  //   }
  // };

  useEffect(() => {
    if (!question) {
      dispatch(userAnswer());
    }

    // Attach event listeners
    // document.addEventListener('keydown', handleKeyDown);
    // document.addEventListener('keyup', handleKeyUp);

    // // Detach event listeners on unmount
    // return () => {
    //   document.removeEventListener('keydown', handleKeyDown);
    //   document.removeEventListener('keyup', handleKeyUp);
    // };
  }, []);

  const messageList = useMemo(
    () => messages[coach].slice(2).map(({ content }) => content),
    [coach, messages],
  );

  useEffect(() => {
    if (chat.current != null && user.status !== STATUS.IDLE) {
      if (audioRequest) {
        setAudioRequest(false);
      } else {
        chat.current.scrollTop = chat.current.scrollHeight - chat.current.clientHeight;
      }
    }

    if (text.current != null) {
      text.current.focus();
    }
  }, [question, user.status]);

  const handleSend = () => {
    // setAnswer(text.current.value);
    dispatch(userAnswer(input));
    setInput('');
  };

  const handleEnter = (event: React.KeyboardEvent) => {
    if (!event.altKey && !event.shiftKey && !event.ctrlKey && event.key === 'Enter') {
      event.preventDefault();
      handleSend();
    }
  };

  // const playAudio = (markdown: string) => {
  //   setAudioRequest(true);
  //   dispatch(userSpeak(removeMd(markdown)));
  // };

  // // Recording
  // const { recording, startRecording, stopRecording, transcript } = useWhisper({
  //   apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  //   removeSilence: true,
  // });
  // // const { changed } = useTreeChanges(transcript);

  // useUpdateEffect(() => {
  //   // if (changed('text')) {
  //   setInput(transcript.text || '');
  //   // }
  // }, [transcript.text]);

  // const handleClickListen = () => {
  //   dispatch(userSpeakFailure());
  //   dispatch(setListen(!listen));
  // };

  return (
    <StyledBox key="Chat" coach={coach} data-testid="Chat">
      <LeftSide>
        {/* <Image
          alt="star"
          src={`${process.env.PUBLIC_URL}/media/images/white_dots.png`}
          style={{ position: 'absolute', top: '60px', width: '100%' }}
        /> */}
        <Image
          alt="triangles"
          src={`${process.env.PUBLIC_URL}/media/images/4-white-dots.png`}
          width={15}
          style={{ position: 'absolute', bottom: '200px', left: '30px' }}
        />
        <Image
          alt="logo"
          src={`${process.env.PUBLIC_URL}/media/images/logo.png`}
          style={{
            position: 'absolute',
            top: '80px',
            left: '80px',
            width: '120%',
            maxWidth: '120%',
          }}
        />
      </LeftSide>
      <RightSide>
        <div style={{ flex: 1 }} />
        <Image
          alt="circles"
          src={`${process.env.PUBLIC_URL}/media/images/circles.png`}
          width={150}
          style={{ position: 'absolute', top: '-50px', right: '-50px' }}
        />
        <Image
          alt="purple_dots"
          src={`${process.env.PUBLIC_URL}/media/images/purple-triangles.png`}
          style={{ alignSelf: 'end', marginTop: '50px', marginRight: '70px' }}
          width={25}
        />
        <div style={{ flex: 1 }} />
        <Image
          alt="white_dots"
          src={`${process.env.PUBLIC_URL}/media/images/star.png`}
          style={{ alignSelf: 'end', marginBottom: '20px', marginRight: '40px' }}
          width={80}
        />
      </RightSide>
      <Image
        alt="venn"
        src={`${process.env.PUBLIC_URL}/media/images/venn-graph.png`}
        style={{
          position: 'absolute',
          left: '-5%',
          width: '120%',
          maxWidth: '120%',
        }}
      />
      <div style={{ display: 'flex', flexDirection: 'row', height: '70%', zIndex: 1 }}>
        <Header />
        <StyledContainer coach={coach}>
          <ul ref={chat}>
            {messageList.map((message, index) => (
              <li key={index}>
                <ReactMarkdown>{message}</ReactMarkdown>
                {/* {listen && user.status !== STATUS.IDLE && index % 2 === 0 && (
                <button onClick={() => playAudio(message)} type="button">
                  <Icon name="play" />
                </button>
              )} */}
              </li>
            ))}
            {user.status !== STATUS.RUNNING &&
              (!question ? null : (
                <li>
                  <ReactMarkdown>{question.replaceAll('\n', '\n\n')}</ReactMarkdown>
                  {/* {listen && user.status !== STATUS.IDLE && (
                  <button onClick={() => playAudio(question)} type="button">
                    <Icon name="play" />
                  </button>
                )} */}
                </li>
              ))}
            {user.status === STATUS.RUNNING && (
              <li>
                <Typing />
              </li>
            )}
          </ul>
          <InputBox>
            <Input
              ref={text}
              disabled={user.status === STATUS.RUNNING}
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
                setInput(event.target.value)
              }
              onKeyDown={handleEnter}
              // onKeyUp={handleKeyUp}
              placeholder="Type your message here!"
              value={input}
            />
            <Button onClick={handleSend}>
              <Icon name="send" width={20} />
            </Button>
          </InputBox>

          {/* <Actions>
          <Listen onClick={handleClickListen}>
            <div className={classNames('icon', { checked: listen })}>
              <Icon name="play" width={20} />
            </div>
            <span>Listen to Your Coach</span>
          </Listen>
          <Record>
            <div className={classNames('icon', { checked: recording })}>
              <Icon name="start-recording" width={16} />
            </div>
            <span>Start / Stop Recording</span>
          </Record>
        </Actions> */}
        </StyledContainer>
      </div>
    </StyledBox>
  );
}

export default Chat;
